export const FETCHING_VEGETATION_INDEX_AVERAGE = 'fetching:vegetation-index-average';
export const FETCH_VEGETATION_INDEX_AVERAGE = 'fetch:vegetation-index-average';
export const FETCHING_VEGETATION_INDEX_CROP= 'fetching:vegetation-index-crop';
export const FETCH_VEGETATION_INDEX_CROP = 'fetch:vegetation-index-crop';
export const FETCHING_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED = 'fetching:vegetation-index-average-for-crop-type-not-confirmed';
export const FETCH_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED = 'fetch:vegetation-index-average-for-crop-type-not-confirmed';
export const FETCH_FAILURE = 'fetch-failure';
export const FETCH_CROP_FAILURE = 'fetch-crop-failure';
export const FETCH_FAILURE_FOR_CROP_TYPE_NOT_CONFIRMED = 'fetch-failure-for-crop-type-not-confirmed';
export const CLEANUP = 'cleanup';
